import { useParamsSearch } from '@anytag/shared-hooks';
import { MarketplaceApplicantsSearchSchemaType } from '../schemaTypes';

export const useMarketplaceApplicantsFilter = () => useParamsSearch<MarketplaceApplicantsSearchSchemaType>();
